module.exports = __webpack_public_path__ + "static/media/TSU.7a280408.png";